import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import Translator from "Languages/Utility/Translator";
import { Dialog, DialogActions } from "@material-ui/core";
import { satc_DiscountCardUsed } from "Constants/TableColumns";
import * as Icons from "react-bootstrap-icons";
import addNumToList from "Helpers/addNumToList";
import MuiButton from "Components/MuiButton/MuiButton";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { read } from "Helpers/LocalStorage";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import StatusHandler from "Helpers/StatusHandler";
import { useTheme } from "@material-ui/core/styles";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

export default function UsedGroup({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showDialog, setShowDialog] = useState(false);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tblData, setTblData] = useState([]);
  const { accountingDiscountCardUsed, pagination } = useSelector((state) => ({
    accountingDiscountCardUsed: state.saAccounts.accountingDiscountCardUsed,
    pagination: state.saAccounts.pagination,
  }));

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onEnter = async () => {
    setLoading(true);
    await getUsedDiscountCard(1, sizePerPage);
  };

  const getUsedDiscountCard = async (_page, _sizePerPage) => {
    setLoading(true);
    return new Promise(async (resolve) => {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Limit: _sizePerPage,
        Page: _page,
        Id: row.Id,
      };
      const response = await AccountService.getAccountingDiscountCardUsed(
        params
      );
      let err = StatusHandler(response);
      if (!err.isFail) {
        setTblData(
          addNumToList(response.data.Value, params.Page, params.Limit)
        );
        setSizePerPage(response.data.Pagination.Limit);
        setCurrentPage(response.data.Pagination.Page);
        setTotal(response.data.Pagination.Total);
      }
      setLoading(false);
      resolve(true);
    });
  };

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      await getUsedDiscountCard(page, sizePerPage);
    }
  };

  const onExit = async () => {
    setShowDialog(false);
    setLoading(false);
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="groups" />}
        icon={<Icons.PersonLinesFill />}
        onClick={onShowDialog}
        className="primary-button"
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onExit}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        fullWidth
        maxWidth="md"
      >
        <form>
          <BackDropLoading loading={loading} />
          <div className="dialogHeader justify-content-start">
            <p>
              <Translator id="groups" />
              {" - "}
              <strong>{`${row.Name}`}</strong>
            </p>
          </div>
          <RemoteTable
            data={tblData}
            columns={satc_DiscountCardUsed}
            loading={loading}
            page={currentPage}
            sizePerPage={sizePerPage}
            totalSize={total}
            onTableChange={onTableChange}
            overflowScroll={true}
            noTitle={true}
          />
          <DialogActions>
            <MuiButton
              onClick={() => setShowDialog(false)}
              title={<Translator id="close" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
